import { createReducer, on } from '@ngrx/store';
import { ODataParams, odataParamsFactory, ODataResponse } from '@tdw/core';
import { LookupValue } from 'src/app/models/lookup.model';
import { PigFamily, PigFamilyConfiguration, PigProduct, PigProductGuideFilters } from 'src/app/models/pig-product.model';

import * as fromGuide from '../fromPigProductGuide.barrel';

export const pigProductGuideFeatureKey = 'pigProductGuide';
export enum Loaders {
  pigProducts = 99,
  lookups,
  loadCutSheet
}

export interface State {
  loaders: Loaders[];
  pigFamilies: PigFamily[];
  pigFamilyConfigurations: PigFamilyConfiguration[];
  pigDiameters: LookupValue[];
  pigProducts?: ODataResponse<PigProduct[]>,
  pigProductParams: ODataParams,
  guideFilters?: PigProductGuideFilters
}

export const initialState: State = {
  loaders: [],
  pigFamilies: [],
  pigFamilyConfigurations: [],
  pigDiameters: [],
  pigProductParams: odataParamsFactory({
    count: true,
    top: 50,
    select: ['id', 'partNumber', 'productname', 'realSealCup', 'biDirectional', 'minimumMetal', 'bodyBypass', 'rebuildable', 'waxParaffin', 'magnet', 'operatingTemp', 'flowSpeed', 'maxRunLength', 'productPh', 'showInSelector', 'preferredProduct', 'inactiveDate'],
    expand: `Diameter($select=id,text), FamilyConfiguration($expand=PigFamilyConfigurationPurposes($expand=PiggingPurpose)),MinBendRadius($select=id,text),Durometer($select=id,text),BypassHoleRequirement($select=id,text),GaugePlateSize($select=id,text)`,
    // orderBy: 'FamilyConfiguration/Family/name,FamilyConfiguration/name,partNumber,'
  })
};

export const reducer = createReducer(
  initialState,
  on(fromGuide.loadPigProducts, (state, action) => ({
    ...state,
    loaders: [...state.loaders, Loaders.pigProducts]
  })),
  on(fromGuide.loadPigProductsSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.pigProducts),
    pigProducts: action.pigProducts
  })),
  on(fromGuide.loadLookups, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.lookups)
  })),
  on(fromGuide.loadLookupsSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.lookups),
    pigFamilies: action.lookups.families,
    pigFamilyConfigurations: action.lookups.familyConfigs,
    pigDiameters: action.lookups.diameters
  })),
  on(fromGuide.goToPage, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.pigProducts),
    pigProductParams: {
      ...state.pigProductParams,
      skip: (state.pigProductParams.top * (action.page - 1))
    }
  })),
  on(fromGuide.changeFilter, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.pigProducts),
    guideFilters: {
      ...state.guideFilters,
      ...action.vals
    }
  })), on(fromGuide.clearFilter, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.pigProducts),
    guideFilters: undefined
  })),
  on(fromGuide.loadCutSheet, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadCutSheet)
  })),
  on(fromGuide.loadCutSheetSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadCutSheet)
  })),
  on(fromGuide.loadCutSheetFailure, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(f => f !== Loaders.loadCutSheet)
  }))
);
